import { Card, CardContent, Grid } from "@mui/material";

import {
  GridColDef,
  GridInitialState,
  GridRenderCellParams,
} from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import { useError } from "../../../contexts/ErrorContext";
import useApi from "../../../hooks/useGaneshApi";
import GaneshDataGrid from "../../DataGrid/GaneshDataGrid";
import { formatNumber } from "utils/formatting";

type PoiBrandDistributionGlobal_T = {
  id: number;
  country_name: string;
  total_branded_poi_count: number;
  total_active_poi_count: number;
  distinct_brands: number;
  poi_percent_branded: number;
};

const defaultGridState: GridInitialState = {
  filter: {
    filterModel: {
      items: [],
    },
  },
  sorting: { sortModel: [] },
  pagination: { paginationModel: { pageSize: 25, page: 0 } },
  pinnedColumns: { left: [] },
  columns: { columnVisibilityModel: {} },
  density: "compact",
};

const PoiBrandDistributionGlobal: React.FC<any> = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [poiBrandDistributionGlobalData, setPoiBrandDistributionGlobalData] =
    useState<PoiBrandDistributionGlobal_T[]>([]);

  const { showError } = useError();
  const { apiRequest } = useApi();

  const fetchPoiBrandDistributionGlobalData = async () => {
    try {
      setLoading(true); // Set loading to true before the API request
      const response = await apiRequest<PoiBrandDistributionGlobal_T[]>(
        `/brand_reports/insights/get_poi_brand_distribution_global`,
        { method: "GET" }
      );
      if (response.data) setPoiBrandDistributionGlobalData(response.data);
    } catch (error) {
      console.error(error);
      showError(`Error fetching brand freshness data.`);
    } finally {
      setLoading(false); // Set loading to false after data is fetched
    }
  };

  useEffect(() => {
    fetchPoiBrandDistributionGlobalData();
  }, []);

  const columns_def: GridColDef[] = [
    { field: "country_name", headerName: "Country", width: 250 },
    {
      field: "total_branded_poi_count",
      headerName: "Total Branded POI Count",
      width: 150,
      renderCell: (params: GridRenderCellParams<Number>) =>
        formatNumber(params.value),
    },
    {
      field: "total_active_poi_count",
      headerName: "Total Active POI Count",
      width: 150,
      renderCell: (params: GridRenderCellParams<Number>) =>
        formatNumber(params.value),
    },
    {
      field: "distinct_brands",
      headerName: "Distinct Brands",
      width: 150,
      renderCell: (params: GridRenderCellParams<Number>) =>
        formatNumber(params.value),
    },
    {
      field: "poi_percent_branded",
      headerName: "POI Percent Branded",
      width: 150,
    },
  ];

  return (
    <Grid container spacing={2}>
      {/* Data Grid Section */}
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <GaneshDataGrid
              loading={loading}
              data={poiBrandDistributionGlobalData}
              columns={columns_def}
              gridId="poiBrandDistributionGlobalGrid"
              defaultGridState={defaultGridState}
              customHeight="400px"
              showGridSaver={false}
              getRowId={(row: PoiBrandDistributionGlobal_T) => row.id}
            />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default PoiBrandDistributionGlobal;
